/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
/*
 * Hover name tooltip for any colour swatch carrying data-swatch-tooltip —
 * addon / upsell swatches (.tac-color-swatch) and the quiz offer swatches.
 *
 * These swatches live inside overflow (scroll/hidden) containers — swatch sliders,
 * the addons popup, cart upsells — so a tooltip rendered *inside* the swatch gets
 * clipped. Instead we render a single shared tooltip appended to <body> with
 * position:fixed, which escapes every ancestor's overflow. The visible name comes
 * from the swatch's `data-swatch-tooltip` attribute.
 *
 * Matches the main variant tooltip look (.pp_selection_label) and, like it, only
 * shows on desktop (>1279px, i.e. hover devices). Loaded globally from
 * theme_body_scripts.liquid, and separately from layout/quiz.liquid, which does
 * not include that snippet.
 */

var deskSwatchTip = null;

function deskEnsureSwatchTip() {
  if (deskSwatchTip) return deskSwatchTip;
  deskSwatchTip = document.createElement('div');
  deskSwatchTip.className = 'desk-swatch-tooltip';
  deskSwatchTip.style.cssText = [
    'position:fixed',
    'z-index:100000',
    'background:#f6f6f6',
    'border-radius:4px',
    'padding:6px 8px 4px',
    'font-size:12px',
    'line-height:1em',
    'color:#19191cb2',
    'box-shadow:0 0 5px #0000001a',
    'white-space:nowrap',
    'pointer-events:none',
    'display:none',
    'transform:translateX(-50%)'
  ].join(';');
  document.body.appendChild(deskSwatchTip);
  return deskSwatchTip;
}

function deskShowSwatchTip(swatch) {
  // Desktop only — matches the main variant tooltip (hidden <=1279px).
  if (window.innerWidth <= 1279) return;
  var text = swatch.getAttribute('data-swatch-tooltip');
  if (!text) return;
  var t = deskEnsureSwatchTip();
  t.textContent = text;
  t.style.display = 'block';
  var r = swatch.getBoundingClientRect();
  t.style.left = r.left + r.width / 2 + 'px';
  t.style.top = r.bottom + 6 + 'px';
}

function deskHideSwatchTip() {
  if (deskSwatchTip) deskSwatchTip.style.display = 'none';
}

function deskSwatchTipOver(e) {
  var swatch = e.target.closest ? e.target.closest('[data-swatch-tooltip]') : null;
  if (swatch) deskShowSwatchTip(swatch);
}

function deskSwatchTipOut(e) {
  var swatch = e.target.closest ? e.target.closest('[data-swatch-tooltip]') : null;
  if (swatch) deskHideSwatchTip();
}

function deskInitSwatchTooltip() {
  if (window.__deskSwatchTooltipInit) return;
  window.__deskSwatchTooltipInit = true;
  // Delegated on document so it works for swatches added later (cart re-render,
  // popup open, etc.) without re-binding.
  document.addEventListener('mouseover', deskSwatchTipOver);
  document.addEventListener('mouseout', deskSwatchTipOut);
  // A fixed tooltip would visually detach on scroll — hide it instead.
  window.addEventListener('scroll', deskHideSwatchTip, true);
}

deskInitSwatchTooltip();
